import { EventEmitter } from '@angular/core';
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
var CasePracticeAuthorizationBeginComponent = (function () {
    function CasePracticeAuthorizationBeginComponent(commonService, apiService) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.onGoToList = new EventEmitter();
        this.onGoToNextStep = new EventEmitter();
    }
    CasePracticeAuthorizationBeginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/taskBook/' + this.exerciseId
        }).subscribe(function (result) {
            _this.taskBook = result;
        });
        // this.taskBook = "";
    };
    CasePracticeAuthorizationBeginComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
    };
    CasePracticeAuthorizationBeginComponent.prototype.close = function () {
        this.onGoToList.emit(true);
    };
    CasePracticeAuthorizationBeginComponent.prototype.goToNextStep = function () {
        this.commonService.setOnceIno(this.commonService.getOnceValue(this.exerciseMetaId, 702)).subscribe();
        this.onGoToNextStep.emit(3);
    };
    return CasePracticeAuthorizationBeginComponent;
}());
export { CasePracticeAuthorizationBeginComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-begin/case-practice-authorization-begin.component.ts.pre-build-optimizer.js